import { Component, HostListener, Input } from '@angular/core';
import { EventsService } from 'simpo-component-library';
import { ImageUploadService } from 'src/app/services/ImageUploadService/image-upload.service';
import { TemplateService } from 'src/app/services/template.service';
import { MediaSelectorComponent } from '../../popups/media-selector/media-selector.component';

@Component({
  selector: 'app-logo-editor',
  templateUrl: './logo-editor.component.html',
  styleUrls: ['./logo-editor.component.scss']
})
export class LogoEditorComponent {

  constructor(
    private eventService: EventsService,
    private templateService: TemplateService,
    private imageUploadService: ImageUploadService) { }

  @Input() logoData: any
  @Input() siteName: any;
  @Input() bgColor: any;
  @Input() componentId: string = '';
  @Input() isLoading: boolean = false;
  ngOnInit() {
    this.screenSize()
  }
  screenWidth: any
  @HostListener ('window:resize', ['$event'])
  screenSize(event? : any){
    this.screenWidth= window.innerWidth
  }

  selectedTab: 'Text + Icon' | 'Image' = "Text + Icon";
  showImageEditor: boolean = false;
  selectedOption: string = 'upload-file';

  max = 100;
  min = 0;
  showTicks = false;
  step = 1;

  changeTabs(selectedTab: 'Text + Icon' | 'Image') {
    this.selectedTab = selectedTab;

  }

  closeDialog() {

  }

  async updateIcon(event: any){
    this.isLoading = true;
    let file = event.target.files[0];
    const maximumFileSize = 4 * 1024 * 1024; // Max is 4mb
    if(maximumFileSize < file.size){
      return;
    }

    const response: any = await this.imageUploadService.uploadPageScreenShots(
      file,
      'library-media'
    );
    this.logoData.text.url = response.Location;
    this.isLoading = false;
  }

  async updateImage() {
    let width = this.screenWidth > 475 ? '50%' : 'auto' ;
    let dialog = this.templateService.openDialogWithData(
      MediaSelectorComponent,
      '90vh',
      width,
      { multiple: false }
    )
    dialog.afterClosed().subscribe(
      (res: any) => {
        this.logoData.image.url = res[0].assets[0].url;
      }
    )
    this.isLoading = false;
  }

  deleteImage(){
    this.logoData.image.url = ''
  }

  deleteIcon(){
     this.logoData.text.url = ''
  }

  emitIconChange() {
    this.eventService.iconChanged.emit({
      id: this.componentId + (this.logoData?.text?.id ?? ''),
      icon: this.logoData?.text
    });
  }
}
